import { AnalystColumnType } from 'src/app/models/analyst-output.model';

const NUMBER_MAX_FRACTION_DIGITS = 4;

const MISSING_VALUE_PLACEHOLDER = '-';

function isBlankCellValue(value: string): boolean {
  return value == null || value.trim() === '';
}

export function formatAnalystCell(value: string, dataType: AnalystColumnType, formatDate: (isoValue: string) => string): string {
  switch (dataType) {
    case AnalystColumnType.Number: {
      if (isBlankCellValue(value)) {
        return MISSING_VALUE_PLACEHOLDER;
      }
      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric.toLocaleString(undefined, { maximumFractionDigits: NUMBER_MAX_FRACTION_DIGITS }) : value;
    }
    case AnalystColumnType.Date: {
      const parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? value : formatDate(value);
    }
    case AnalystColumnType.Boolean: {
      const normalized = value.toLowerCase();
      if (normalized === 'true') {
        return 'Yes';
      }
      if (normalized === 'false') {
        return 'No';
      }
      return value;
    }
    default:
      return value;
  }
}
